import { gql } from 'graphql-request'

export namespace AgentMutations {
  export function updateAgentStatus() {
    return gql`
      mutation updateAgentStatus($agentStatus: AgentStatusMutation) {
        updateAgentStatus(agentStatus: $agentStatus) {
          id
        }
      }
    `
  }

  export function createAgent() {
    return gql`
      mutation createAgent($agent: AgentInsertMutation!) {
        createAgent(agent: $agent) {
          id
          name
        }
      }
    `
  }

  export function updateAgent() {
    return gql`
      mutation updateAgent($agent: AgentUpdateMutation!) {
        updateAgent(agent: $agent) {
          id
          name
        }
      }
    `
  }

  export function deleteAgent() {
    return gql`
      mutation deleteAgent($agentId: Int!) {
        deleteAgent(id: $agentId)
      }
    `
  }
}
